import { ValueOf } from 'types/types';

const SortOrder = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

type SortOrder = ValueOf<typeof SortOrder>;

export { SortOrder };
